'use client';

import { ServerErrorIllustration } from 'src/assets/illustrations';

import { ErrorPageLayout } from './components/error-page-layout';

// ----------------------------------------------------------------------

/** `/error/500` — 서버 오류 */
export function View500() {
  return (
    <ErrorPageLayout
      title="서버에 문제가 생겼습니다"
      description="잠시 뒤 다시 시도해 주세요. 계속 이러면 알려 주시면 살펴보겠습니다."
      illustration={<ServerErrorIllustration sx={{ my: { xs: 5, sm: 10 } }} />}
      actionLabel="홈으로 가기"
    />
  );
}
